import { SUBSCRIPTION_STATUS } from '~/types/subscription';

/**
 * Single source of truth for the PolyLLM "restore vs paywall" decision
 * (JD-2817). Restore only makes sense when there is a prior plan that can
 * actually be brought back; every other status (never subscribed / after
 * free tier / paused / redemption …) must fall through to the upgrade
 * paywall — so the paywall predicate is the negation of this one rather
 * than a separate `status === none` allow-list.
 */
export function shouldShowPolyllmRestoreModal(
  status: SUBSCRIPTION_STATUS | undefined,
): boolean {
  if (!status) {
    return false;
  }

  return status === SUBSCRIPTION_STATUS.CANCELLED;
}
